import { render, staticRenderFns } from "./PreScreeningTransaction.vue?vue&type=template&id=1fcfe646"
import script from "./PreScreeningTransaction.vue?vue&type=script&lang=js"
export * from "./PreScreeningTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports